﻿import React from 'react';
import styled from 'styled-components';
import hexToRgba from 'hex-to-rgba';

import Button from '../../../vendor/react-validation/components/button';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

const ValidationButton = (props) => {
    const { onMouseEnter, onMouseLeave, topMargin, noIcon, ...allProps } = { ...props };

    return (
        <ButtonWrapper onMouseLeave={onMouseLeave} noIcon={noIcon}>
            <Button onMouseEnter={onMouseEnter} {...allProps}>{props.children}</Button>
        </ButtonWrapper>
    );
}


const ButtonWrapper = styled.div`
    display: inline-block; 
    width: auto;

    button {
        padding: 10px 20px 10px 20px;
        ${mediaQuery.large(`
            padding: 12px 15px 12px 15px;
        `)}

        font-family: ${definitions.fonts.heading};
        font-weight: bold;
        color: white;

        background-color: ${definitions.colors.green};
        border-radius: 5px;

        transition: background-color 300ms ease-out;

        &:after {
            color: white;
            padding-left: 20px;
            font-size: 14px;

            ${props => !props.noIcon ? iconCode.arrowRight() : ''};
        }

        &:disabled {
            background-color: ${hexToRgba(definitions.colors.green, 0.5)};
            cursor: not-allowed;
        }
    }
`;

export default ValidationButton;
